import { render, staticRenderFns } from "./prospectos.vue?vue&type=template&id=d8b43680&"
import script from "./prospectos.vue?vue&type=script&lang=js&"
export * from "./prospectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports